import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable, defer, distinctUntilChanged, map, startWith } from 'rxjs';
import { WizardComponent } from './wizard.component';

@Component({
  selector: 'insol-wizard-bar',
  templateUrl: './wizard-bar.component.html',
})
export class WizardBarComponent implements OnChanges {
  @Input() wizard: WizardComponent;
  @Input() isDirty: boolean;
  @Output() cancel = new EventEmitter<void>();
  @Output() finish = new EventEmitter<void>();

  canBack$: Observable<boolean>;
  canNext$: Observable<boolean>;
  canFinish$: Observable<boolean>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['wizard']) {
      if (this.wizard) {
        this.canBack$ = this.createChangeObservable(() => this.wizard.canBack);
        this.canNext$ = this.createChangeObservable(() => this.wizard.canNext);
        this.canFinish$ = this.createChangeObservable(() => this.wizard.canFinish);
      } else {
        this.canBack$ = this.canNext$ = this.canFinish$ = null;
      }
    }
  }

  onCancel(): void {
    if (this.isDirty) {
      this.cancel.next();
    }
  }

  onFinish(): void {
    if (this.wizard?.canFinish) {
      this.finish.next();
    }
  }

  private createChangeObservable(predicate: () => boolean): Observable<boolean> {
    return defer(() => this.wizard.changes.pipe(map(predicate), startWith(predicate()), distinctUntilChanged()));
  }
}
